export class MapMarker{
    id:number=0;
    position:{lat:number, lng:number}={lat:0, lng:0};
    pinHtml:string="";
    overlayHtml:string="";
}